import { Box } from '@mui/system'
import { useFormContext } from 'react-hook-form'
import { CompactFieldRow } from '../../../form/compactFieldRow'
import { FormTextField } from '../../../form/textfield'
import styled from '@emotion/styled'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'

const FormBox = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	gap: '12px',
}))

export default function RecipientInfoForm() {
	const { t } = useTranslation()
	const { control } = useFormContext()

	return (
		<FormBox>
			<CompactFieldRow
				firstchildren={
					<div className=" flex flex-col">
					<FormTextField
						name="name"
						control={control}
						label={t('Name')}
						mandatory
					/>
				
					</div>
					
				}
				secondchildren={
					
					<FormTextField
						name="position"
						control={control}
						label={t('Position')}
						mandatory
					/>
					
					
				}
			/>
			<CompactFieldRow
				firstchildren={
					<FormTextField
						name="phone"
						control={control}
						label={t('Phone Number')}
						type="tel"
						mandatory	
					/>
				}
				secondchildren={<Box />}
			/>
		</FormBox>
	)
}
